import http from "@/utils/axios";
import { apiPaths } from "@/dictionaries/api/paths";

export default {
  namespaced: true,
  state: {
    visits: [],
    errors: [],
    pagination: {
      currentPage: 1,
      total: 1,
    },
    services: [],
    selectedService: ''
  },
  getters: {
    getVisits: (state) => state.visits,
    getErrors: (state) => state.errors,
    getPagination: (state) => state.pagination,
    getServices: (state) => state.services,
    getSelectedService: (state) => state.selectedService,
  },
  mutations: {
    setVisits(state, visits) {
      state.visits = visits.data;
      state.pagination.currentPage = visits.meta.current_page;
      state.pagination.total = visits.meta.last_page;
    },
    setErrors(state, errors) {
      state.errors = errors;
    },
    addError(state, { key, error }) {
      state.errors = {
        ...state.errors,
        [key]: error,
      };
    },
    clearErrors(state) {
      state.errors = [];
    },
    setCurrentPage(state, currentPage) {
      state.pagination.currentPage = currentPage;
    },
    setServices(state, services) {
      state.services = services;
    },
    setSelectedService(state, selectedService) {
      state.selectedService = selectedService;
    },
    clearServices(state) {
      state.services = [];
    },
    clearSelectedService(state) {
      state.selectedService = '';
    },
    clearVisits(state) {
      state.visits = [];
      state.pagination.currentPage = 1;
      state.pagination.total = 1;
    },
  },
  actions: {
    async fetchPatientVisits({ commit, state }, {patientId, event_type}) {
      const response = await http.get(`${apiPaths.doctor.patients.meetings}/${patientId}`, {
        params: {
          event_type: event_type,
          calendar_service: state.selectedService,
          page: state.pagination.currentPage,
        },
      });
      const data = response.data;
      commit("setVisits", data.meetings);
    },

    async fetchPatientVisitsServices({ commit }, {patientId, event_type}) {
      const response = await http.get(`${apiPaths.doctor.patients.services}/${patientId}/services`, {
        params: {
          event_type: event_type,
        },
      });
      const data = response.data;
      commit("setServices", data.services);
    },

  },
};
